// Labels for "Send Items to App" (selection mode, confirmation, status).

// Arabic number agreement: صنف واحد / صنفان / ٣-١٠ أصناف / ١١+ صنفاً.
const itemsAr = (n) => (n === 1 ? "صنف واحد" : n === 2 ? "صنفين" : n >= 3 && n <= 10 ? `${n} أصناف` : `${n} صنفاً`);
const selectedItemsAr = (n) => (n === 1 ? "الصنف المحدد" : n === 2 ? "الصنفين المحددين" : n >= 3 && n <= 10 ? `${n} أصناف محددة` : `${n} صنفاً محدداً`);
const TEXT = {
  ar: {
    action: "إرسال الأصناف للتطبيق",
    selectApp: "اختر التطبيق",
    selectApps: "اختر التطبيقات",
    selectAllApps: "تحديد كل التطبيقات",
    clearApps: "مسح التطبيقات",
    noApps: "لا توجد تطبيقات توصيل مرتبطة بهذا المطعم.",
    appNotConfigured: "لم يُضبط بريد هذا التطبيق",
    appsFailed: "تعذر تحميل التطبيقات",
    selectItems: "حدد الأصناف المراد إرسالها",
    selectedCount: (n) => `تم تحديد ${itemsAr(n)}`,
    selectAll: "تحديد كل المتاح",
    counts: (total, available, unavailable) => `الأصناف: ${total} · متاح للإرسال: ${available} · غير متاح: ${unavailable}`,
    eligibilityFailed: "تعذر التحقق من أهلية الأصناف للإرسال",
    cannotSendHidden: "لا يمكن الإرسال — الصنف مخفي",
    cannotSendMissingOne: (field) => `لا يمكن الإرسال — ينقصه: ${field}`,
    cannotSendMissing: "لا يمكن الإرسال — ينقصه:",
    missingFields: { name: "اسم الصنف", name_ar: "الاسم بالعربية", name_en: "الاسم بالإنجليزية", description_ar: "الوصف بالعربية", description_en: "الوصف بالإنجليزية", image: "الصورة", price: "سعر صحيح", section: "اسم القسم", additions: "بيانات إضافات مكتملة" },
    clear: "مسح التحديد",
    cancel: "إلغاء",
    close: "إغلاق",
    send: (n) => `إرسال ${itemsAr(n)}`,
    sendHint: "اختر الإجراء والتطبيق وحدد صنفاً واحداً على الأقل.",
    actionLabel: "الإجراء",
    selectAction: "اختر الإجراء",
    actions: { add: "إضافة", update: "تحديث", delete: "حذف" },
    historyAction: (action, app) => `${{ add: "إضافة", update: "تحديث", delete: "حذف" }[action] || action} ← ${app}`,
    deleteRequested: (app) => `طلب حذف: ${app}`,
    selectItem: (name) => `تحديد ${name}`,
    confirmTitle: (n, app, action) => ({ add: `إضافة ${selectedItemsAr(n)} إلى ${app}؟`, update: `تحديث ${selectedItemsAr(n)} في ${app}؟`, delete: `حذف ${selectedItemsAr(n)} من ${app}؟` })[action],
    confirmBody: (n, app, action) => `سيتم إرسال بريد إلكتروني إلى ${app} (طلب ${{ add: "إضافة", update: "تحديث", delete: "حذف" }[action]}) يتضمن تفاصيل ${itemsAr(n)}. لن يُرسل أي شيء قبل التأكيد.`,
    confirmSend: "إرسال",
    sentOk: (n, app, action) => `تم إرسال طلب ${{ add: "إضافة", update: "تحديث", delete: "حذف" }[action]} لـ ${itemsAr(n)} إلى ${app}`,
    historyWarning: " — لكن تعذر حفظ سجل الإرسال.",
    modeOn: "إنهاء وضع الإرسال",
    sentCurrent: "أُرسلت النسخة الحالية",
    sentUpdated: "تغيّر الصنف بعد الإرسال",
    updatedLegend: "↻ تغيّر منذ الإرسال",
    statusDetail: (app, state, date, count) => `${app} — ${state} (${date}${count > 1 ? `، ${count} مرات` : ""})`,
    historyTitle: (name) => `سجل الإرسال: ${name}`,
    historyEmpty: "لم يُرسل هذا الصنف بعد.",
    historyLoading: "جاري التحميل...",
    historyFailed: "تعذر تحميل السجل",
    reference: "المرجع",
    sentBy: "بواسطة",
    sentToApp: "أُرسل إلى",
    currentVersion: "النسخة الحالية",
    olderVersion: "نسخة أقدم",
    itemsInSend: (n) => `${n} أصناف في هذا الإرسال`,
    errors: {
      EMAIL_FAILED: "تعذر إرسال البريد الإلكتروني. لم يُسجل أي إرسال، حاول مرة أخرى.",
      EMAIL_DISABLED: "إرسال البريد الإلكتروني معطل على الخادم. لم يُرسل شيء.",
      APP_EMAIL_NOT_CONFIGURED: "لم يُضبط بريد إلكتروني لهذا التطبيق.",
      APP_NOT_AVAILABLE: "هذا التطبيق غير مرتبط بالمطعم.",
      INVALID_APP: "التطبيق غير مدعوم.",
      ITEMS_NOT_FOUND: "بعض الأصناف لم تعد موجودة في قائمة الطعام. حدّث الصفحة وحاول مرة أخرى.",
      INVALID_ITEM_IDS: "الأصناف المحددة غير صالحة.",
      SEND_IN_PROGRESS: "هذا الإرسال قيد المعالجة بالفعل.",
      MENU_ARCHIVED: "لا يمكن إرسال أصناف قائمة طعام مؤرشفة.",
      ITEMS_NOT_ELIGIBLE: "بعض الأصناف المحددة لا يمكن إرسالها (مخفية أو غير مكتملة). لم يُرسل شيء.",
      INVALID_ACTION: "الإجراء غير صالح.",
      APP_CC_NOT_CONFIGURED: "لم يُضبط بريد النسخة (CC) لهذا التطبيق. لم يُرسل شيء.",
      APP_CC_INVALID: "بريد النسخة (CC) المضبوط لهذا التطبيق غير صالح. لم يُرسل شيء.",
      STORE_EMAIL_INVALID: "بريد المطعم مفقود أو غير صالح. لم يُرسل شيء.",
      APP_RESTAURANT_CODE_MISSING: "لا يوجد كود للمطعم في هذا التطبيق (بيانات دخول المتجر). لم يُرسل شيء.",
      EXCEL_FAILED: "تعذر إنشاء ملف Excel. لم يُرسل شيء.",
    },
  },
  en: {
    action: "Send Items to App",
    selectApp: "Select app",
    selectApps: "Select apps",
    selectAllApps: "Select all apps",
    clearApps: "Clear apps",
    noApps: "No delivery apps are set up for this restaurant.",
    appNotConfigured: "No email configured for this app (CC)",
    appsFailed: "Could not load the apps",
    selectItems: "Select the items to send",
    selectedCount: (n) => `${n} selected`,
    selectAll: "Select all available",
    counts: (total, available, unavailable) => `${total} ${total === 1 ? "item" : "items"} · ${available} available to send · ${unavailable} unavailable`,
    eligibilityFailed: "Could not check which items can be sent",
    cannotSendHidden: "Cannot send — item is hidden",
    cannotSendMissingOne: (field) => `Cannot send — missing ${field}`,
    cannotSendMissing: "Cannot send — missing:",
    missingFields: { name: "item name", name_ar: "Arabic name", name_en: "English name", description_ar: "Arabic description", description_en: "English description", image: "image", price: "valid price", section: "section name", additions: "complete additions" },
    clear: "Clear",
    cancel: "Cancel",
    close: "Close",
    send: (n) => `Send ${n} ${n === 1 ? "Item" : "Items"}`,
    sendHint: "Choose an action and an app, and select at least one item.",
    actionLabel: "Action",
    selectAction: "Select action",
    actions: { add: "Add", update: "Update", delete: "Delete" },
    historyAction: (action, app) => `${{ add: "Add", update: "Update", delete: "Delete" }[action] || action} → ${app}`,
    deleteRequested: (app) => `Delete requested: ${app}`,
    selectItem: (name) => `Select ${name}`,
    confirmTitle: (n, app, action) => {
      const items = `${n} selected ${n === 1 ? "item" : "items"}`;
      return { add: `Add ${items} to ${app}?`, update: `Update ${items} on ${app}?`, delete: `Delete ${items} from ${app}?` }[action];
    },
    confirmBody: (n, app, action) => `An email (${action} request) with the details of ${n} ${n === 1 ? "item" : "items"} will be sent for ${app}. Nothing is sent before you confirm.`,
    confirmSend: "Send",
    sentOk: (n, app, action) => `${{ add: "Add", update: "Update", delete: "Delete" }[action]} request sent: ${n} ${n === 1 ? "item" : "items"} · ${app}`,
    historyWarning: " — but the send history could not be saved.",
    modeOn: "Exit Send Mode",
    sentCurrent: "Current version sent",
    sentUpdated: "Updated since sent",
    updatedLegend: "↻ Updated since sent",
    statusDetail: (app, state, date, count) => `${app} — ${state} (${date}${count > 1 ? `, ${count}×` : ""})`,
    historyTitle: (name) => `Send history: ${name}`,
    historyEmpty: "This item has not been sent yet.",
    historyLoading: "Loading...",
    historyFailed: "Could not load the history",
    reference: "Reference",
    sentBy: "By",
    sentToApp: "Sent to",
    currentVersion: "Current version",
    olderVersion: "Older version",
    itemsInSend: (n) => `${n} items in this send`,
    errors: {
      EMAIL_FAILED: "The email could not be sent. Nothing was recorded; try again.",
      EMAIL_DISABLED: "Email sending is disabled on the server. Nothing was sent.",
      APP_EMAIL_NOT_CONFIGURED: "No email address is configured for this app.",
      APP_NOT_AVAILABLE: "This app is not set up for the restaurant.",
      INVALID_APP: "This app is not supported.",
      ITEMS_NOT_FOUND: "Some items are no longer in this menu. Refresh and try again.",
      INVALID_ITEM_IDS: "The selected items are not valid.",
      SEND_IN_PROGRESS: "This send is already being processed.",
      MENU_ARCHIVED: "Items of an archived menu cannot be sent.",
      ITEMS_NOT_ELIGIBLE: "Some selected items cannot be sent (hidden or incomplete). Nothing was sent.",
      INVALID_ACTION: "The action is not valid.",
      APP_CC_NOT_CONFIGURED: "No CC email is configured for this app. Nothing was sent.",
      APP_CC_INVALID: "The CC email configured for this app is invalid. Nothing was sent.",
      STORE_EMAIL_INVALID: "The restaurant email is missing or invalid. Nothing was sent.",
      APP_RESTAURANT_CODE_MISSING: "The restaurant has no restaurant code for this app (store user info). Nothing was sent.",
      EXCEL_FAILED: "The Excel file could not be generated. Nothing was sent.",
    },
  },
};

export const sendToAppText = (lang) => TEXT[lang] || TEXT.ar;
